import { render, staticRenderFns } from "./reportcase-manage.vue?vue&type=template&id=cb558000"
import script from "./reportcase-manage.vue?vue&type=script&lang=ts"
export * from "./reportcase-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports